import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { busesSelector } from 'reduxModules/selectors/GlobalSelectors'
import { globalActions } from 'reduxModules/actions/GlobalActions'
import withSorting from 'hoc/withSorting'

import { BusesBase } from './Buses'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  buses: busesSelector,
})

const mapDispatchToProps = {
  setBus: globalActions.setBus,
  deleteBus: globalActions.deleteBus,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withSorting
)

export const Buses = enhance(BusesBase)



// WEBPACK FOOTER //
// ./src/components/Buses/index.js